import React, { useContext, useEffect } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Typography, useTheme } from '@zydalabs/zac-react';
import moment from 'moment';

import * as translations from 'constants/translations';
import { context as localeContext } from 'context/locale';
import { context as userContext } from 'context/user';

const StoreRider = ({ rider, verd, selected, setSelected }) => {
  const { lang, translate } = useContext(localeContext);
  const {
    selectedStore: { timeZone },
  } = useContext(userContext);

  const { colors } = useTheme();
  const isArabic = lang === 'ar';

  const { id: riderId, assignedOrdersCount, name, onShift, phone, lastAssignedAt } = rider || {};

  const riderHasFullCapacity = assignedOrdersCount >= verd?.driverMaxCapacity;

  const lastAssignedTime = moment(lastAssignedAt)
    .tz(timeZone)
    .locale(isArabic ? 'ar' : 'en-gb')
    .fromNow();

  const isRiderSelected = selected?.id === riderId;

  useEffect(() => {
    if (selected?.id === riderId) setSelected(rider);
  }, [rider]);

  return (
    <div
      className={cx(
        'w-100 flex justify-between border rounded-lg mb-2 py-3 px-4 cursor-pointer items-end',
        isRiderSelected && 'border-blue-500 bg-blue-100',
        riderHasFullCapacity ? 'bg-gray-100 cursor-default' : 'cursor-pointer',
      )}
      onClick={() => {
        if (!riderHasFullCapacity) {
          setSelected(rider);
        }
      }}
      aria-hidden="true"
    >
      <div className="flex flex-col">
        <div className="flex gap-1">
          <Typography variant="heading14" cursor={!riderHasFullCapacity && 'pointer'}>
            {name}
          </Typography>
          <Typography variant="body14" cursor={!riderHasFullCapacity && 'pointer'} color={colors.gray[600]}>
            {phone}
          </Typography>
        </div>
        <div>
          <div className={cx('text-xs inline-block w-auto', isArabic ? 'ml-1' : 'mr-1')}>
            <Typography variant="body12" color={riderHasFullCapacity ? colors.red[600] : colors.success.primary}>
              {translate(riderHasFullCapacity ? translations.MAX_CAPACITY : translations.AVAILABLE)}
            </Typography>
          </div>
          {onShift && assignedOrdersCount > 0 && (
            <div className="text-xs inline-block w-auto">
              <Typography variant="body12" color={colors.gray[600]} cursor={!riderHasFullCapacity && 'pointer'}>
                {translate(translations.UNDERSCORE)}
                {translate(translations.ASSIGNED_ORDERS(rider.assignedOrdersCount))}
              </Typography>
            </div>
          )}
        </div>
      </div>
      <Typography variant="body14" color={colors.gray[600]} cursor={!riderHasFullCapacity && 'pointer'}>
        {lastAssignedTime}
      </Typography>
    </div>
  );
};

StoreRider.propTypes = {
  rider: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    phoneNumber: PropTypes.string,
    assignedOrdersCount: PropTypes.number,
    onShift: PropTypes.bool,
  }),
  verd: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    displayNameEn: PropTypes.string,
    displayNameAr: PropTypes.string,
  }),
};

export default StoreRider;
